import MiMarkupTable from './MiMarkupTable.vue'

export default MiMarkupTable
